<template>
  <div class="pa-5">
    <v-select
      v-model="selectedMedia"
      :items="items"
      item-text="label"
      item-value="deviceId"
      @input="changeCamera"
    ></v-select>
  </div>
</template>

<script>
import { twilioMixin } from '@/mixins/twilioMixin.js'
import { mapState } from 'vuex'

export default {
  name: 'ModalSelectCamera',

  mixins: [twilioMixin],

  data() {
    return {
      items: [],
      selectedMedia: null
    }
  },

  computed: {
    ...mapState({
      roomDevicesVideo: state => state.roomDevices.video
    })
  },

  async mounted() {
    this.items = await this.getInputDevices('video')
    const local = localStorage.getItem('videoDeviceId') || this.roomDevicesVideo.deviceId
    const deviceId = this.items.find(el => el.deviceId === local)
    if (deviceId) this.selectedMedia = deviceId.deviceId
  },

  methods: {
    changeCamera(deviceId) {
      this.saveNewDevice('video', deviceId)
    }
  }
}
</script>
